import { Card, Input, message } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectCoachNotesDetails, setCoachSummaryAsync } from "slices/dashboardSlice";
import "./CoachSummary.css"
import moment from "moment";
import HELPERS from "utils/helper";
import {debounce} from "lodash";

const { TextArea } = Input;

const CoachSummary = () => {
  
  const coachSummary = useSelector(selectCoachNotesDetails);
  console.log('sss coachSummary', coachSummary)
  const dispatch = useDispatch();
  const userId = HELPERS.getUserId()
  
  const [isEditing, setIsEditing] = useState(false);
  const [showSaveAndCancel, setShowSaveAndCancel] = useState(false);
  const [textAreaValue, setTextAreaValue] = useState(coachSummary?.note || '');

  const handleContentChange = useCallback(
    debounce((content) => {
      const payload = {
        coachSummary: content,
      };
      console.log('sss patchSummary', payload)
      dispatch(setCoachSummaryAsync(payload, userId))
      message.success("Your work has been saved")
    }, 1000), // Debounce delay of 1 second
    []
  );
  
  useEffect(() => {
    return () => {
      handleContentChange.cancel();
    };
  }, [handleContentChange]);

  const handleTextAreaChange = (e) => {
    setTextAreaValue(e.target.value);
    // handleContentChange(e.target.value); // Pass string, not event
  };

  const handleSave = () => {
    console.log('sss textAreaValue', textAreaValue);
    handleContentChange(textAreaValue)
    setShowSaveAndCancel(false);
  };

  useEffect(() => {
    const isCoach = localStorage.getItem('isCoach')
    isCoach ? setIsEditing(true) : setIsEditing(false)
  }, []);
    
  return (
    <>
      <Card
        bordered={false}
        className="dashboard-coach-summary"
        style={{
            borderRadius: "12px",
            textAlign: "left",
            margin: "0px 20px",
            height: "fit-content",
        }}
        >
        <div className="h" style={{ fontWeight: "bold", textAlign: "left", borderLeft: "5px solid #B2DADB", paddingLeft: "15px" }}>
          <div className="stg-header">
            <div className="stg-left-header">
                <span className="my-career-roadmap-title">Coach's Summary</span>
            </div>
            {
              isEditing && 
                <div className="stg-right-header">
                  <img
                    src="https://django-woken-static.s3.amazonaws.com/static/media/editbtn.svg"
                    alt="edit"
                    style={{ cursor: "pointer" }}
                    onClick={()=>{setShowSaveAndCancel(!showSaveAndCancel)}}
                  />
                </div>
            }
          </div>
            <div className="coach-summary-body">
              { 
                !showSaveAndCancel &&
                  <div className="coach-summary-note" style={{ opacity: `${textAreaValue ? 1 : 0.4}`, }}>
                      {textAreaValue || "Your coach will fill out periodic updates and feedback for you here"}
                  </div>
              }
              {
                showSaveAndCancel &&
                  <TextArea
                    rows={4}
                    value={textAreaValue}
                    onChange={handleTextAreaChange}
                    placeholder="Your coach will fill out periodic updates and feedback for you here"
                  ></TextArea>
              }
              {
                showSaveAndCancel && 
                  <div 
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      columnGap: "15px",
                      marginTop: "10px",
                      marginBottom: "5px"
                    }}
                  >
                    <button type="button" onClick={() => {setShowSaveAndCancel(false);setTextAreaValue(coachSummary?.note || '')}} className="button-secondary" style={{ width: "10%", minWidth: "max-content" }}>Cancel</button>
                    <button type="submit" className="button-main" style={{ width: "10%", minWidth: "max-content" }} onClick={handleSave}>Save</button>
                  </div>
              }
              <div className="coach-summary-coach-name">
                {/* <div>
                    🎖️ Keep it up {coachSummary.first_name} !
                </div> */}
                {
                  (coachSummary.last_updated && textAreaValue) &&
                    <div style={{ fontStyle: "italic", opacity: "0.4", }}>
                        Updated on: {moment(coachSummary.last_updated).format("MM/DD/YYYY")}
                    </div>
                }
              </div>
            </div>
        </div>
      </Card>
    </>
  )
}

export default CoachSummary